import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, vModelText as _vModelText, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal fade show",
  style: {"display":"block"}
}
const _hoisted_2 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header bg-accent text-white" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h6", { class: "modal-title" }, "Pilihan Lainnya", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Close", -1)
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = { class: "modal-body py-4" }
const _hoisted_10 = { class: "row flex-nowrap mx-n1" }
const _hoisted_11 = { class: "col-12 px-1" }
const _hoisted_12 = { class: "form-group row" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "col-form-label col-sm-4" }, "Jenis", -1)
const _hoisted_14 = { class: "col-sm-8" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: "",
  selected: ""
}, "Pilih Jenis", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("option", { value: "1" }, "Voucher", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("option", { value: "2" }, "Diskon", -1)
const _hoisted_18 = [
  _hoisted_15,
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = {
  key: 0,
  class: "form-group row"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", {
  class: "col-form-label col-sm-4",
  for: "voucherCode"
}, "Kode Voucher", -1)
const _hoisted_21 = { class: "col-sm-8" }
const _hoisted_22 = {
  key: 1,
  class: "form-group row"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", {
  class: "col-form-label col-sm-4",
  for: "discountValue"
}, "Nominal Diskon", -1)
const _hoisted_24 = { class: "col-sm-8" }
const _hoisted_25 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.modalVisible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("button", {
                type: "button",
                class: "close",
                "data-dismiss": "modal",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.hideModal && _ctx.hideModal(...args))),
                "aria-label": "Close"
              }, _hoisted_8)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("p", null, "Total Bayar: " + _toDisplayString(_ctx.payTotal), 1),
                  _createElementVNode("form", null, [
                    _createElementVNode("div", _hoisted_12, [
                      _hoisted_13,
                      _createElementVNode("div", _hoisted_14, [
                        _withDirectives(_createElementVNode("select", {
                          class: "form-control",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.kppType) = $event)),
                          placeholder: "Pilih Jenis"
                        }, _hoisted_18, 512), [
                          [_vModelSelect, _ctx.kppType]
                        ]),
                        _createElementVNode("div", {
                          class: "invalid-feedback",
                          style: _normalizeStyle(_ctx.kppTypeStyle)
                        }, _toDisplayString(_ctx.kppTypeErr), 5)
                      ])
                    ]),
                    (_ctx.kppType == 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                          _hoisted_20,
                          _createElementVNode("div", _hoisted_21, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "form-control",
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.voucherCode) = $event)),
                              placeholder: "Masukan kode voucher",
                              id: "voucherCode"
                            }, null, 512), [
                              [_vModelText, _ctx.voucherCode]
                            ]),
                            _createElementVNode("div", {
                              class: "invalid-feedback",
                              style: _normalizeStyle(_ctx.voucherStyle)
                            }, _toDisplayString(_ctx.voucherErr), 5)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.kppType == 2)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                          _hoisted_23,
                          _createElementVNode("div", _hoisted_24, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "form-control numeric",
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.discountValue) = $event)),
                              placeholder: "Masukan nominal diskon",
                              id: "discountValue"
                            }, null, 512), [
                              [_vModelText, _ctx.discountValue]
                            ]),
                            _createElementVNode("div", {
                              class: "invalid-feedback",
                              style: _normalizeStyle(_ctx.discountStyle)
                            }, _toDisplayString(_ctx.discountErr), 5)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-danger",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args)))
              }, "Batal"),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-success",
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
              }, "Simpan")
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}